module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[93]214.99e83c3.woff2";